/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  aiMl,
  backendDevelopment,
  cyberSecurity,
  dataAnalyticsAndBI,
  dataEngineering,
  devopsSre,
  emergingTechnologies,
  frontendDevelopment,
  fullStack,
  mobileApplication,
  platformEngineeringSreOracle,
  qualityAssurance,
  Others,
  Product,
  Project,
  SemiConductor,
  UIDesign,
} from '@jobseeker/lotus/assets/icons';

const APP_NAME_IIMJOBS = 'iimjobs';
const APP_NAME_HIRIST = 'hirist';
const THEME = 'theme';
const HOME = 'home';
const CATEGORY = 'category';
const LOCATION_BASED = 'location_based';
const CAT_LOCATION_BASED = 'category_location_based';
const EPOCH_ROUND_ONE = 'epoch-round-one';
const EPOCH_ROUND_TWO = 'epoch-round-two';
const EPOCH_ROUND_THREE = 'epoch-round-three';
const EPOCH = 'epoch';
const EPOCH_REGISTER = 'epoch-register';
const EPOCH_TERMS = 'epoch-terms';
const EPOCH_WINNERS = 'epoch-winners';
const UNSUBSCRIBE = 'unsubscribe';
const REACTIVATE = 'reactivate';
const TAG = 'tag';
const APP = 'app';
const NOTFOUND = 'notfound';
const DOWNLOADAPP = 'downloadapp';
const ABOUTUS = 'aboutus';
const COMPANY = 'company';
const COMPANY_CAREER = 'company-career';

const CONTACTUS = 'contact';
const REFUND = 'refund';
const PRIVACY = 'privacy';
const COOKIEPOLICY = 'cookiepolicy';
const GRIEVANCES = 'grievances';
const TERMS = 'terms';
const FAQ = 'faq';
const CHATS = 'chats';
const SITEMAP = 'sitemap';
const DEACTIVATE = 'deactivate';
const INTERVIEWS = 'interviews';
const VIDEO_CHAT = 'interview';
const JOBFEED = 'jobfeed';
const RECRUITER_JOBFEED = 'recruiterJobfeed';
const RESET_PASSWORD = 'resetpassword';
const SAVEDJOBS = 'savedjobs';
const APPLIEDJOBS = 'appliedjobs';
const RECRUITER_VIEW = 'recruiterview';
const NOTIFICATIONS = 'allnotification';
const JOBAPPLIED = 'jobapplied';
const SETTINGS = 'settings';
const JOBDETAIL = 'jobdetail';
const APPLIEDJOB = 'appliedjob';
const SEARCH = 'search';
const ALUMNI = 'alumni';
const COOKIE_CKT = '_CK1';
const COOKIE_LASTACT = '_LASTACT';
const LOCATION = 'location';
const PERSONALIZE_JOBFEED = 'personalize-jobfeed';
const REGISTRATION = 'registration';
const REGISER_PERSONAL_DETAILS = 'registration-personaldetail';
const REGISTER_WORK_EXPERIENCE = 'registration-workexperience';
const REGISTER_EDUCATIONAL_DETAILS = 'registration-educationaldetail';
const REGISTER_ADDITIONAL_DETAILS = 'registration-additionaldetail';
const REGISTER_COVERLETTERANDSKILLS = 'registration-coverletterandskills';
const REGISTER_AUDIO_VIDEO_PROFILE = 'registration-audiovideoprofile';
const UPDATE_PROFILE = 'update-profile';
const HIRIST_AUTHENTICATION = 'hirist-authentication';
const WOMEN_AT_WORK = 'women_at_work';
const ENGINEERS_WEEK = 'engineers_week';
const PRO_TALENT = 'pro_talent';
const COURSE = 'course';
const SIMILAR_COURSE = 'similar-course';
const UNPUBLISHED_COURSE_DETAIL = 'unpublished-course-detail';
const UNPUBLISHED_COURSE_LIST = 'unpublished-course-list';
const LEARNING = 'learning';
const TALENT_BRIDGE = 'talentBridge';
const MYPROFILE = 'myprofile';
const PENDING_RECOMMENDATIONS = 'pendingrecommendations';
const SOCIAL_CONNECTION = 'socialconnection';
const CV_ANALYZER = 'cv-analyzer';
const DREAM_COMPANY = 'dream-company';
// Common Good Bots Allowlist (SEO / AEO / GEO Focused)
const BOTUSERAGENTS = [
  // AI Crawlers (High Relevance for AI Search & Answer Engines)
  'GPTBot',
  'ChatGPT-User',
  'OAI-SearchBot',
  'ClaudeBot',
  'PerplexityBot',
  'Google-Extended',
  'Applebot-Extended',
  'CCBot',
  // Traditional Search Engine Crawlers (Core SEO Traffic Sources)
  'Googlebot-Image',
  'Googlebot-Video',
  'Googlebot-News',
  'Googlebot',
  'GoogleOther',
  'Bingbot',
  'BingPreview',
  'DuckDuckBot',
  'Applebot',
  'Slurp',
  // Validation & Verification Bots (Keep for SEO Console & Ownership Checks)
  'Google-InspectionTool',
  'Google-Site-Verification',
  'AdsBot-Google',
  'Feedfetcher-Google',
  'Google-Read-Aloud',
];
const MYJOBFEED = 'My Jobfeed';
const SLUG_SUFFIX = '-jobs';
const REF_REDIRECT_OLD = 'red_old';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
const RESUME_BUILDER = 'resume-builder';
const CONSENT = 'consent';
const PLANS_PAGE = 'plans';
const COMPETITION_ID = 3;
const SUBSCRIPTIONSUCCESS = 'subscriptionsuccess';

const EXPERIENCE_MAPPING_HIRIST = [
  {minexp: 0, maxexp: 30},
  {minexp: 0, maxexp: 1},
  {minexp: 2, maxexp: 3},
  {minexp: 4, maxexp: 6},
  {minexp: 7, maxexp: 10},
  {minexp: 11, maxexp: 15},
  {minexp: 16, maxexp: 20},
  {minexp: 21, maxexp: 25},
  {minexp: 26, maxexp: 100},
];

const TAG_ID_HIRIST = new Map([
  ['c-plus-plus-jobs', {name: 'c-plus-plus-jobs', tagName: 'C++', id: '10'}],
  [
    'vc-plus-plus-jobs',
    {name: 'vc-plus-plus-jobs', tagName: 'VC++', id: '502'},
  ],
  ['x-plus-plus-jobs', {name: 'x-plus-plus-jobs', tagName: 'X++', id: '368'}],
  [
    'c-c-plus-plus-architect-jobs',
    {
      name: 'c-c-plus-plus-architect-jobs',
      tagName: 'C/C++ Architect',
      id: '2312',
    },
  ],
  [
    'c-plus-plus11-jobs',
    {name: 'c-plus-plus11-jobs', tagName: 'C++11', id: '11873'},
  ],
  [
    'embedded-c-plus-plus-jobs',
    {
      name: 'embedded-c-plus-plus-jobs',
      tagName: 'Embedded C++',
      id: '167317,28106',
    },
  ],
  [
    'c-plus-plus14-jobs',
    {name: 'c-plus-plus14-jobs', tagName: 'C++14', id: '33824'},
  ],
  [
    'project-manager-c-c-plus-plus-jobs',
    {
      name: 'project-manager-c-c-plus-plus-jobs',
      tagName: 'Project Manager - C/C++',
      id: '2377',
    },
  ],
]);

const EXPERIENCE_MAPPING = isAppIimjobs
  ? [
      {minexp: 0, maxexp: 30},
      {minexp: 0, maxexp: 1},
      {minexp: 2, maxexp: 3},
      {minexp: 4, maxexp: 6},
      {minexp: 7, maxexp: 10},
      {minexp: 11, maxexp: 15},
      {minexp: 16, maxexp: 20},
      {minexp: 21, maxexp: 25},
      {minexp: 25, maxexp: 100},
    ]
  : EXPERIENCE_MAPPING_HIRIST;

const PRO_MEMBERSHIP = 'pro-membership';
const EARLY_APPLICANT_PREFERENCE = 'early-applicant-preference';
const PENDINGASSESSMENTS = 'pendingassessments';

const EPOCH_LEGAL_VERSION = 1;
const ENABLE_REVIEW_AND_SUBMIT = true;

const ALIAS_TO_COMPETITION_ID: Record<string, number> = {
  epoch: 5,
  'x-clause': 4,
};

export {
  ABOUTUS,
  APP,
  APP_NAME_HIRIST,
  APP_NAME_IIMJOBS,
  APPLIEDJOB,
  APPLIEDJOBS,
  BOTUSERAGENTS,
  CAT_LOCATION_BASED,
  CATEGORY,
  CHATS,
  COMPANY,
  COMPANY_CAREER,
  CONTACTUS,
  COOKIE_CKT,
  COOKIE_LASTACT,
  COOKIEPOLICY,
  COURSE,
  TAG_ID_HIRIST,
  DEACTIVATE,
  DREAM_COMPANY,
  DOWNLOADAPP,
  EARLY_APPLICANT_PREFERENCE,
  EPOCH,
  EPOCH_REGISTER,
  EPOCH_ROUND_ONE,
  EPOCH_ROUND_THREE,
  EPOCH_ROUND_TWO,
  EPOCH_TERMS,
  EPOCH_WINNERS,
  EXPERIENCE_MAPPING,
  FAQ,
  GRIEVANCES,
  HIRIST_AUTHENTICATION,
  HOME,
  INTERVIEWS,
  JOBAPPLIED,
  JOBDETAIL,
  JOBFEED,
  LEARNING,
  LOCATION,
  LOCATION_BASED,
  MYJOBFEED,
  NOTFOUND,
  NOTIFICATIONS,
  PENDINGASSESSMENTS,
  TALENT_BRIDGE,
  PERSONALIZE_JOBFEED,
  PRIVACY,
  PRO_MEMBERSHIP,
  RECRUITER_JOBFEED,
  RECRUITER_VIEW,
  REF_REDIRECT_OLD,
  REFUND,
  REGISER_PERSONAL_DETAILS,
  REGISTER_ADDITIONAL_DETAILS,
  REGISTER_AUDIO_VIDEO_PROFILE,
  REGISTER_COVERLETTERANDSKILLS,
  REGISTER_EDUCATIONAL_DETAILS,
  REGISTER_WORK_EXPERIENCE,
  REGISTRATION,
  RESET_PASSWORD,
  SAVEDJOBS,
  SEARCH,
  ALUMNI,
  SETTINGS,
  SIMILAR_COURSE,
  SITEMAP,
  SLUG_SUFFIX,
  TAG,
  TERMS,
  THEME,
  UNPUBLISHED_COURSE_DETAIL,
  UNPUBLISHED_COURSE_LIST,
  UNSUBSCRIBE,
  VIDEO_CHAT,
  WOMEN_AT_WORK,
  ENGINEERS_WEEK,
  RESUME_BUILDER,
  PLANS_PAGE,
  UPDATE_PROFILE,
  REACTIVATE,
  PRO_TALENT,
  MYPROFILE,
  PENDING_RECOMMENDATIONS,
  SOCIAL_CONNECTION,
  CONSENT,
  COMPETITION_ID,
  SUBSCRIPTIONSUCCESS,
  EPOCH_LEGAL_VERSION,
  ALIAS_TO_COMPETITION_ID,
  CV_ANALYZER,
  ENABLE_REVIEW_AND_SUBMIT,
};

const ROUTE_JOBFEED = '/jobfeed';
const ROUTE_NOTFOUND = '/notfound';
const ROUTE_SEARCH = '/search';
const ROUTE_HOME = '/';
const ROUTE_JOB_DETAIL = '/j';
const ROUTE_CATEGORY = '/c';
const ROUTE_TAG = '/k';
const ROUTE_FILTER = '/filter';
const ROUTE_JOB_APPLIED = '/job/applied';
const ROUTE_SAVED_JOBS = '/saved-jobs';
const ROUTE_PLAN_PAGE = '/subscribe/plans';

const NON_CITY_LOCATION_IDS = [
  0, 8, 9, 10, 13, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30,
  31, 32, 33, 34, 35, 59, 64, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98,
  99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114,
  115, 116, 117, 118, 119, 120, 122, 123, 124, 125, 126, 127, 128, 129, 132,
  100000,
];

const CATEGORY_ARRAY = [
  {dataId: '14', label: 'AI/ML', tag: 'ai/ml'},
  {dataId: '7', label: 'Data Analytics & BI', tag: 'data analytics & bi'},
  {dataId: '1', label: 'Backend Development', tag: 'backend development'},
  {dataId: '16', label: 'Full Stack', tag: 'full stack'},
  {dataId: '2', label: 'Frontend Development', tag: 'frontend development'},
  {dataId: '5', label: 'Mobile Applications', tag: 'mobile applications'},
  {dataId: '15', label: 'Data Engineering', tag: 'data engineering'},
  {dataId: '8', label: 'DevOps/SRE', tag: 'devops/sre'},
  {dataId: '9', label: 'Emerging Technologies', tag: 'emerging technologies'},
  {dataId: '12', label: 'Product Management', tag: 'product management'},
  {dataId: '11', label: 'Quality Assurance', tag: 'quality assurance'},
  {
    dataId: '6',
    label: 'Platform Engineering/SAP/Oracle',
    tag: 'platform engineering/sap/oracle',
  },
  {dataId: '4', label: 'Semiconductor/VLSI/EDA', tag: 'semiconductor/vlsi/eda'},
  {
    dataId: '13',
    label: 'Business Analysis and Project Management',
    tag: 'business analysis and project management',
  },
  {dataId: '17', label: 'CyberSecurity', tag: 'cybersecurity'},
  {dataId: '10', label: 'UI & Design', tag: 'ui & design'},
  {dataId: '3', label: 'Others', tag: 'others'},
];

const BLOGLIST = [
  'Career Advice',
  'Interview Questions',
  'Technology',
  'Appraisals',
  'Insights',
  'Interview Advice',
];

const SUPERCOMPANIES = [
  {name: 'Amazon', slug: 'amazon-development-centre-india'},
  {name: 'Paytm', slug: 'paytm'},
  {name: 'Ola', slug: 'ola-cabs'},
  {name: 'Spinny', slug: 'spinny'},
  {name: 'Redbus', slug: 'redbus'},
  {name: 'Byjus', slug: 'byjus'},
  {name: 'Dream11', slug: 'dream-sports-india'},
  {name: 'Unacademy', slug: 'unacademy'},
  {name: 'Upgrad', slug: 'upgrad'},
  {name: 'Shiprocket', slug: 'shiprocket'},
  {name: 'Delhivery', slug: 'delhivery'},
  {name: 'Accenture', slug: 'accenture'},
  {name: 'Microsoft', slug: 'microsoft-corporation'},
  {name: 'Jp-morgan', slug: 'jpmorgan-chase-co'},
  {name: 'Physics-wallah', slug: 'physicswallah'},
  {name: 'Carwale', slug: 'cartrade'},
  {name: 'Cashkaro', slug: 'pouring-pounds'},
  {name: 'Wheelseye', slug: 'wheelseye-technology'},
];
const MAJOR_CITIES = [
  'mumbai',
  'bangalore',
  'delhi-ncr',
  'hyderabad',
  'chennai',
  'pune',
];
export const cities = [
  {
    id: 1,
    locationName: 'Bangalore',
    locationNameLower: 'bangalore',
  },
  {
    id: 2,
    locationName: 'Pune',
    locationNameLower: 'pune',
  },
  {
    id: 3,
    locationName: 'Chennai',
    locationNameLower: 'chennai',
  },
  {
    id: 4,
    locationName: 'Hyderabad',
    locationNameLower: 'hyderabad',
  },
  {
    id: 5,
    locationName: 'Mumbai',
    locationNameLower: 'mumbai',
  },
  {
    id: 6,
    locationName: 'Delhi NCR',
    locationNameLower: 'delhi-ncr',
  },
  {
    id: 7,
    locationName: 'Kolkata',
    locationNameLower: 'kolkata',
  },
  {
    id: 8,
    locationName: 'Coimbatore',
    locationNameLower: 'coimbatore',
  },
  {
    id: 9,
    locationName: 'Noida',
    locationNameLower: 'noida',
  },
  {
    id: 10,
    locationName: 'Gurgaon/Gurugram',
    locationNameLower: 'gurgaon-gurugram',
  },
  {
    id: 11,
    locationName: 'Indore',
    locationNameLower: 'indore',
  },
  {
    id: 12,
    locationName: 'Jaipur',
    locationNameLower: 'jaipur',
  },
  {
    id: 13,
    locationName: 'Chandigarh',
    locationNameLower: 'chandigarh',
  },
  {
    id: 14,
    locationName: 'Delhi',
    locationNameLower: 'delhi',
  },
  {
    id: 15,
    locationName: 'Gurgaon/Gurugram',
    locationNameLower: 'gurgaon-gurugram',
  },
  {
    id: 16,
    locationName: 'Noida',
    locationNameLower: 'noida',
  },
  {
    id: 17,
    locationName: 'Greater Noida',
    locationNameLower: 'greater-noida',
  },
  {
    id: 18,
    locationName: 'Faridabad',
    locationNameLower: 'faridabad',
  },
  {
    id: 19,
    locationName: 'Ghaziabad',
    locationNameLower: 'ghaziabad',
  },
  {
    id: 20,
    locationName: 'Jammu & Kashmir',
    locationNameLower: 'jammu-kashmir',
  },
  {
    id: 21,
    locationName: 'Jammu',
    locationNameLower: 'jammu',
  },
  {
    id: 22,
    locationName: 'Srinagar',
    locationNameLower: 'srinagar',
  },
  {
    id: 23,
    locationName: 'Amritsar',
    locationNameLower: 'amritsar',
  },
  {
    id: 24,
    locationName: 'Jalandhar',
    locationNameLower: 'jalandhar',
  },
  {
    id: 25,
    locationName: 'Patiala',
    locationNameLower: 'patiala',
  },
  {
    id: 26,
    locationName: 'Sonipat',
    locationNameLower: 'sonipat',
  },
  {
    id: 27,
    locationName: 'Panipat',
    locationNameLower: 'panipat',
  },
  {
    id: 28,
    locationName: 'Ludhiana',
    locationNameLower: 'ludhiana',
  },
  {
    id: 29,
    locationName: 'Udaipur',
    locationNameLower: 'udaipur',
  },
  {
    id: 30,
    locationName: 'Jodhpur',
    locationNameLower: 'jodhpur',
  },
  {
    id: 31,
    locationName: 'Ahmedabad',
    locationNameLower: 'ahmedabad',
  },
  {
    id: 32,
    locationName: 'Surat',
    locationNameLower: 'surat',
  },
  {
    id: 33,
    locationName: 'Gandhinagar',
    locationNameLower: 'gandhinagar',
  },
  {
    id: 34,
    locationName: 'Vadodara/Baroda',
    locationNameLower: 'vadodara-baroda',
  },
  {
    id: 35,
    locationName: 'Haridwar',
    locationNameLower: 'haridwar',
  },
  {
    id: 36,
    locationName: 'Uttarakhand',
    locationNameLower: 'uttarakhand',
  },
  {
    id: 37,
    locationName: 'Lucknow',
    locationNameLower: 'lucknow',
  },
  {
    id: 38,
    locationName: 'Patna',
    locationNameLower: 'patna',
  },
  {
    id: 39,
    locationName: 'Jamshedpur',
    locationNameLower: 'jamshedpur',
  },
  {
    id: 40,
    locationName: 'Ranchi',
    locationNameLower: 'ranchi',
  },
  {
    id: 41,
    locationName: 'Chhattisgarh',
    locationNameLower: 'chhattisgarh',
  },
  {
    id: 42,
    locationName: 'Bhubaneshwar',
    locationNameLower: 'bhubaneshwar',
  },
  {
    id: 43,
    locationName: 'Nagpur',
    locationNameLower: 'nagpur',
  },
  {
    id: 44,
    locationName: 'Nasik',
    locationNameLower: 'nasik',
  },
  {
    id: 45,
    locationName: 'Navi Mumbai',
    locationNameLower: 'navi-mumbai',
  },
  {
    id: 46,
    locationName: 'Dehradun',
    locationNameLower: 'dehradun',
  },
  {
    id: 47,
    locationName: 'Thane',
    locationNameLower: 'thane',
  },
  {
    id: 48,
    locationName: 'Cochin/Kochi',
    locationNameLower: 'cochin-kochi',
  },
  {
    id: 49,
    locationName: 'Hosur',
    locationNameLower: 'hosur',
  },
  {
    id: 50,
    locationName: 'Trivandrum/Thiruvananthapuram',
    locationNameLower: 'trivandrum-thiruvananthapuram',
  },
  {
    id: 51,
    locationName: 'Raipur',
    locationNameLower: 'raipur',
  },
  {
    id: 52,
    locationName: 'Mysore',
    locationNameLower: 'mysore',
  },
  {
    id: 53,
    locationName: 'Hubli',
    locationNameLower: 'hubli',
  },
  {
    id: 54,
    locationName: 'Vijayawada',
    locationNameLower: 'vijayawada',
  },
  {
    id: 55,
    locationName: 'Vishakhapatnam/Vizag',
    locationNameLower: 'vishakhapatnam-vizag',
  },
  {
    id: 56,
    locationName: 'Guntur',
    locationNameLower: 'guntur',
  },
  {
    id: 57,
    locationName: 'Aurangabad',
    locationNameLower: 'aurangabad',
  },
  {
    id: 58,
    locationName: 'Rajkot',
    locationNameLower: 'rajkot',
  },
  {
    id: 59,
    locationName: 'Warangal',
    locationNameLower: 'warangal',
  },
  {
    id: 60,
    locationName: 'Varanasi/Banaras',
    locationNameLower: 'varanasi-banaras',
  },
  {
    id: 61,
    locationName: 'Madurai',
    locationNameLower: 'madurai',
  },
  {
    id: 62,
    locationName: 'Coimbatore',
    locationNameLower: 'coimbatore',
  },
  {
    id: 63,
    locationName: 'Pondicherry',
    locationNameLower: 'pondicherry',
  },
  {
    id: 64,
    locationName: 'Cuttack',
    locationNameLower: 'cuttack',
  },
];

const PopularTags = [
  {
    id: 5,
    name: 'Mobile Applications',
    alias: 'Mobile Applications',
    tags: [
      {
        id: 56,
        name: 'Android Developer',
        alias: 'Android Jobs',
        key: 'Android',
      },
      {id: 63, name: 'iOS Developer', alias: 'iOS Jobs', key: 'iOS'},
      {id: 68, name: 'Phonegap Developer', key: 'Phonegap'},
      {
        id: 0,
        name: 'Swift/Objective C Developer',
        searchString: 'Swift Objective C',
      },
    ],
    icon: 'icon-mobile-applications-jobs',
    meta: '',
  },
  {
    id: 2,
    name: 'Frontend Development',
    alias: 'Frontend Development',
    tags: [
      {id: 0, name: 'Frontend Developer', searchString: 'Frontend Development'},
      {id: '1900', name: 'Mean Stack Developer', key: 'Mean'},
      {
        id: 26,
        name: 'Javascript Engineer',
        alias: 'Javascript Jobs',
        key: 'Javascript',
      },
      {id: '434', name: 'Node.js Developer', key: 'Nodejs'},
    ],
    icon: 'icon-frontend-developer-jobs',
    meta: '',
  },
  {
    id: 1,
    name: 'Backend Development',
    alias: 'Backend Development',
    tags: [
      {id: 0, name: 'Backend Developer', searchString: 'Backend Development'},
      {id: 5, name: 'Java Developer', alias: 'Java Jobs', key: 'Java'},
      {id: 9, name: 'Python Developer', alias: 'Python Jobs', key: 'Python'},
      {id: '7', name: '.NET Developer', key: 'Net'},
    ],
    icon: 'icon-backend-developer-jobs',
    meta: '',
  },
  {
    id: 8,
    name: 'DevOps/SRE',
    alias: 'DevOps / SRE',
    tags: [
      {id: 0, name: 'DevOps Engineer', searchString: 'DevOps Engineer'},
      {id: '73', name: 'Network Administration', key: 'Network Administration'},
      {id: 1239, name: 'Azure', alias: 'Azure Jobs', key: 'Azure'},
      {id: '2631', name: 'Docker', key: 'Docker'},
      {id: '1551', name: 'Jenkins', key: 'Jenkins'},
    ],
    icon: 'icon-devops-jobs',
    meta: '',
  },
  {
    id: 9,
    name: 'Emerging Technologies',
    alias: 'Emerging Technologies',
    tags: [
      {
        id: 2240,
        name: 'Block Chain Developer',
        alias: 'Blockchain Jobs',
        key: 'Blockchain',
      },
      {id: '1641', name: 'iOT', key: 'iOT'},
      {
        id: 2211,
        name: 'Augmented Reality',
        alias: 'Augmented Reality Jobs',
        key: 'Augmented Reality',
      },
      {
        id: 2672,
        name: 'Virtual Reality',
        alias: 'Virtual Reality Jobs',
        key: 'Virtual Reality',
      },
      {id: '2625', name: 'Cryptography', key: 'Cryptography'},
    ],
    icon: 'icon-emerging-technologies-roles',
    meta: '',
  },
  {
    id: 7,
    name: 'Data Analytics & BI',
    alias: 'Data Analytics & BI',
    tags: [
      {id: '2023', name: 'Data Scientist', key: 'Data Scientist'},
      {id: '2111', name: 'Data Analyst', key: 'Data Analytics'},
      {id: '1400', name: 'Business Intelligence', key: 'Business Intelligence'},
      {id: '600', name: 'Tableau', key: 'Tableau'},
      {id: '2574', name: 'Power BI', key: 'Power BI'},
    ],
    icon: 'icon-analytics-data-science',
    meta: '',
  },
  {
    id: 13,
    name: 'Business Analysis and Project Management',
    alias: 'Project Management',
    tags: [
      {
        id: 156,
        name: 'Business Analyst',
        alias: 'Business Analyst Jobs',
        key: 'Business Analyst',
      },
      {
        id: 30,
        name: 'Project Manager',
        alias: 'Project Management Jobs',
        key: 'Project Management',
      },
      {id: '280', name: 'Scrum Master', key: 'Scrum'},
      {
        id: 98,
        name: 'Program Manager',
        alias: 'Program Management Jobs',
        key: 'Program Management',
      },
    ],
    icon: 'icon-project-managment',
    meta: '',
  },
  {
    id: 12,
    name: 'Product Management',
    alias: 'Product Management',
    tags: [
      {id: '28', name: 'Product Manager', key: 'Product Management'},
      {id: 0, name: 'Product Specialist', searchString: 'Product Specialist'},
      {id: 0, name: 'Product Owner', searchString: 'Product Owner'},
      {id: '2910', name: 'Product Roadmap', key: 'Product Roadmap'},
    ],
    icon: 'icon-product-managment',
    meta: '',
  },
  {
    id: 10,
    name: 'UI & Design',
    alias: 'UI & Design',
    tags: [
      {id: 0, name: 'Graphic Designer', searchString: 'Graphic Designer'},
      {id: '2915', name: 'Product Design', key: 'Product Design'},
      {id: 49, name: 'UI Designer', alias: 'UI Jobs', key: 'UI'},
      {id: 2, name: 'UX Designer', alias: 'UX Jobs', key: 'UX'},
    ],
    icon: 'icon-ui-design',
    meta: '',
  },
  {
    id: 4,
    name: 'Semiconductor/VLSI/EDA',
    alias: 'Semiconductor/VLSI/EDA',
    tags: [
      {id: 0, name: 'Embedded Engineeer', searchString: 'Embedded Engineeer'},
      {id: 426, name: 'RTL Design Engineer', alias: 'RTL Jobs', key: 'RTL'},
      {id: 191, name: 'Verilog', alias: 'Verilog Jobs', key: 'Verilog'},
      {id: '402', name: 'MATLAB', key: 'MATLAB'},
      {id: '197', name: 'VHDL', key: 'VHDL'},
    ],
    icon: 'icon-semiconductor-vlsi-eda',
    meta: '',
  },
  {
    id: 11,
    name: 'Quality Assurance',
    alias: 'Quality Assurance',
    tags: [
      {id: 0, name: 'Quality Analyst', searchString: 'Quality Analyst'},
      {id: 0, name: 'Test Engineer', searchString: 'Test Engineer'},
      {id: '187', name: 'Automation Testing', key: 'Automation Testing'},
      {id: '353', name: 'Selenium', key: 'Selenium'},
    ],
    icon: 'icon-quality-assurance',
    meta: '',
  },
  {
    id: 6,
    name: 'Platform Engineering/SAP/Oracle',
    alias: 'Platform Engineering / SAP/Oracle',
    tags: [
      {
        id: 455,
        name: 'Pega Developer',
        alias: 'Pega Developer Jobs',
        key: 'Pega',
      },
      {
        id: 268,
        name: 'Sharepoint Developer',
        alias: 'Sharepoint Jobs',
        key: 'Sharepoint',
      },
      {id: '217', name: 'ABAP Developer', key: 'SAP ABAP'},
      {id: '2317', name: 'Informatica', key: 'Informatica Architect'},
    ],
    icon: 'icon-enterprise-sap-oracle',
    meta: '',
  },
  {
    id: 3,
    name: 'Others',
    alias: 'Others',
    tags: [
      {id: '336', name: 'Technical Writer', key: 'Technical Writer'},
      {
        id: 2639,
        name: 'Cyber Security',
        alias: 'Cyber Security Jobs',
        key: 'Cyber Security',
      },
      {
        id: 1610,
        name: 'Ethical Hacking',
        alias: 'Ethical Hacking Jobs',
        key: 'Ethical Hacking',
      },
      {id: '1331', name: 'Internship', key: 'Internship'},
      {id: '1499', name: 'Walkin', key: 'Walkin'},
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 14,
    name: 'AI/ML',
    alias: 'AI/ML',
    tags: [
      {id: '203', name: 'Machine Learning Engineer', key: 'Machine Learning'},
      {
        id: 898,
        name: 'Artificial Intelligence',
        alias: 'Artificial Intelligence Jobs',
        key: 'Artificial Intelligence',
      },
      {
        id: 135480,
        name: 'Generative AI',
        alias: 'Generative AI Jobs',
        key: 'Generative AI',
      },
      {id: '2512', name: 'Deep Learning', key: 'Deep Learning'},
      {id: '357', name: 'NLP', key: 'NLP'},
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 15,
    name: 'Data Engineering',
    alias: 'Data Engineering',
    tags: [
      {id: '111', name: 'Big Data', key: 'Big Data'},
      {id: 112, name: 'Hadoop', alias: 'Hadoop Jobs', key: 'Hadoop'},
      {
        id: 7049,
        name: 'Data Pipeline',
        alias: 'Data Pipeline Jobs',
        key: 'Data Pipeline',
      },
      {id: '2475', name: 'Data Integration', key: 'Data Integration'},
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 16,
    name: 'Full Stack',
    alias: 'Full Stack',
    tags: [
      {id: '1612', name: 'Full Stack Developer', key: 'Full Stack'},
      {
        id: 2696,
        name: 'MERN Stack Developer',
        alias: 'MERN Stack Jobs',
        key: 'MERN Stack',
      },
      {
        id: 1900,
        name: 'MERN Stack Developer',
        alias: 'MEAN Stack Jobs',
        key: 'MEAN',
      },
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 17,
    name: 'CyberSecurity',
    alias: 'CyberSecurity',
    tags: [
      {id: '2623', name: 'Data Security', key: 'Data Security'},
      {
        id: 2584,
        name: 'Cloud Security',
        alias: 'Cloud Security Jobs',
        key: 'Cloud Security',
      },
      {id: 452, name: 'IAM', alias: 'IAM Jobs', key: 'IAM'},
    ],
    icon: 'icon-others',
    meta: '',
  },
  {
    id: 0,
    name: 'Popular',
    alias: 'Popular for job',
    tags: [
      {
        id: '2023',
        name: 'Data Scientist',
        alias: 'Data Science',
        key: 'Data Scientist',
      },
      {id: '9', name: 'Python', alias: 'Python', key: 'Python'},
      {
        id: '203',
        name: 'Machine Learning',
        alias: 'Machine Learning',
        key: 'Machine Learning',
      },
      {
        id: 0,
        name: 'Android IOS',
        alias: 'Android/IOS',
        searchString: 'Android iOS',
      },
      {
        id: 0,
        name: 'Angular React JS',
        alias: 'Angular /React .JS',
        searchString: 'Angular React JS',
      },
      {id: '2696', name: 'MERN', alias: 'MERN', key: 'MERN Stack'},
      {id: 0, name: 'UX Designer', alias: 'UX', searchString: 'UX Designer'},
      {
        id: '30',
        name: 'Project Manager',
        alias: 'Project Manager',
        key: 'Project Management',
      },
      {
        id: '28',
        name: 'Product Manager',
        alias: 'Product manager',
        key: 'Product Management',
      },
      {id: '1612', name: 'Full Stack', alias: 'Full Stack', key: 'Full Stack'},
      {
        id: '17730',
        name: 'Data Analyst',
        alias: 'Data Analyst',
        key: 'Data Analyst',
      },
      {
        id: 0,
        name: 'Backend Developer Jobs',
        alias: 'Backend',
        searchString: 'Backend Developer',
      },
      {id: 0, name: 'Fintech Jobs', alias: 'Fintech'},
      {id: 0, name: 'Startup Jobs', alias: 'Startup'},
      {id: 0, name: 'Frontend Jobs', alias: 'Frontend'},
    ],
    icon: 'icon-others',
    meta: '',
  },
];

const CATEGORY_ICONS_LINKS: {[categoryId: number]: string | any} = {
  14: aiMl,
  7: dataAnalyticsAndBI,
  15: dataEngineering,
  16: fullStack,
  5: mobileApplication,
  1: backendDevelopment,
  2: frontendDevelopment,
  9: emergingTechnologies,
  8: devopsSre,
  17: cyberSecurity,
  12: Product,
  13: Project,
  10: UIDesign,
  6: platformEngineeringSreOracle,
  11: qualityAssurance,
  4: SemiConductor,
  3: Others,
};

const HIRIST_CATEGORY_ROUTE_MAPPING: {[key: string]: string} = {
  'backend-developer': 'backend-development',
  'frontend-developer': 'frontend-development',
  devops: 'devops-sre',
  'emerging-technologies-roles': 'emerging-technologies',
  'analytics-data-science-roles': 'data-analytics-bi',
  'project-management': 'business-analysis-and-project-management',
  'enterprise-sap-oracle': 'platform-engineering-sap-oracle',
};

const NUDGE_ALLOWED_REFS = [
  'ep',
  'tm',
  'recom_email',
  'recom_apply',
  'recom_ev',
  'ep_sec2',
  'ev_recom_seg4',
  'ev_recom_seg7',
  'ev_premium_jobs',
  'recom',
  'psj',
  'recom_ev_com',
  'recom_ev_ml',
  'recom_bn',
  'jf_pml',
  'jobseeker_com',
  'recom_ev_tag',
  'recom_night_ml',
  'recom_night_tag',
];

const BOTTOM_SHEET_COPIES = [
  {
    heading: 'Experience more on the app',
    subHeading: 'Get notified instantly on new jobs and every recruiter action',
    CTA: 'Continue on App',
  },
  {
    heading: 'A smoother job search awaits on the app',
    subHeading: 'Instant notifications and a cleaner, faster application flow.',
    CTA: 'Open in App',
  },
  {
    heading: 'Stay updated. Stay ahead.',
    subHeading: 'Instant application alerts — only on the iimjobs app.',
    CTA: 'Continue on App',
  },
];
export {getJobfeedActionSrc} from './jobfeedActionSrc';

export {
  BLOGLIST,
  CATEGORY_ARRAY,
  CATEGORY_ICONS_LINKS,
  HIRIST_CATEGORY_ROUTE_MAPPING,
  MAJOR_CITIES,
  NON_CITY_LOCATION_IDS,
  PopularTags,
  ROUTE_CATEGORY,
  ROUTE_FILTER,
  ROUTE_HOME,
  ROUTE_JOB_APPLIED,
  ROUTE_JOB_DETAIL,
  ROUTE_JOBFEED,
  ROUTE_NOTFOUND,
  ROUTE_PLAN_PAGE,
  ROUTE_SAVED_JOBS,
  ROUTE_SEARCH,
  ROUTE_TAG,
  SUPERCOMPANIES,
  NUDGE_ALLOWED_REFS,
  BOTTOM_SHEET_COPIES,
};
